import { KEYBOARD_KEYS } from '../constants';
export class KeyboardEventHelper {
    static disableAcceptKeys<T>(e: React.KeyboardEvent<T>) {
        if (KeyboardEventHelper.isAcceptKey(e)) {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    static isAcceptKey<T>(e: React.KeyboardEvent<T>) {
        const key = e.key as KEYBOARD_KEYS;
        const validKeys = [
            KEYBOARD_KEYS.ENTER,
            KEYBOARD_KEYS.SPACE,
            KEYBOARD_KEYS.SPACEBAR,
        ];
        return validKeys.indexOf(key) >= 0;
    }
}



// WEBPACK FOOTER //
// ./src/utils/KeyboardEventHelper.ts